//攻略请求

import base from './base'; // 导入接口域名列表
import axios from './http'; // 导入http中创建的axios实例
// import { debuglog } from 'util';
import qs from "qs"; // 根据需求是否导入qs模块


const activity = {
    //活动类型接口
    activityBookingType() {
        return axios.get(`${base.fm}/activity_booking/type`);
    },
    //activity_booking/list
    //活动列表
    activityBookingList(params) {
        return axios.get(`${base.fm}/activity_booking/list`, params);
    },
    //活动详情
    activityBookingDetail(params) {
        return axios.get(`${base.fm}/activity_booking/detail`, params);
    },
    //发布活动
    activityBookingPost(params) {
        return axios.post(`${base.fm}/activity_booking/post`, qs.stringify(params));
    },
    //管理列表
    activityBookingManager(params) {
        return axios.get(`${base.fm}/activity_booking/manager/list`, params);
    },
    //上传图片
    uploadOssImage(params) {
     
        return axios.post(`${base.fm}/upload/oss`, params);
    },
    //编辑或者取消
    activity_bookingManagerOperation(params) {
     
        return axios.get(`${base.fm}/activity_booking/manager/operation`, params);
    },

 // 新鲜事详情
 noveltyDetail(novelty_id) {
  
    return axios.get(`${base.fm}/novelty/detail?novelty_id=${novelty_id}`,{});
  
  },
  getReviewList(params){
    return axios.get(`${base.fm}/review/list`, params);

  },
   //评论详情点赞
   reviewLike(params){
    return axios.post(`${base.fm}/review/like`, qs.stringify(params));

  },
  //评论详情点赞
  eassyLike(params){
    return axios.post(`${base.fm}/review/target/like`, qs.stringify(params));

  },
  videoDetail(params) {

    return axios.get(`${base.fm}/novelty/shortvideo/list`,params);
  
  },
}

export default activity;


// WEBPACK FOOTER //
// ./src/api/activity.js